import React, { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import { Box, Button, Typography, Select, MenuItem, FormControl } from "@mui/material"
import style from "./style";
import color from "../../../../constants/color"
import {ReactComponent as Download}from "../../../../assets/ViewLeave-images/download.svg";
import dayjs from "dayjs";


const CashFlowStatement = ({getCashFlow,data,handleDownload}) => {
  const [month, setMonth] = useState(dayjs().format("MMMM"))
  const [year, setYear] = useState(dayjs().format("YYYY"))
  const [viewType,setViewType] = useState("monthly")

  useEffect(() => {
    getCashFlow(month,year,viewType)
  },[])
  const months = Array.from({ length: 12 }, (_, i) =>
    new Intl.DateTimeFormat("en", { month: "long" }).format(new Date(2000, i))
  );
  const handleCashFlow = () => {
    getCashFlow(month,year,viewType)
  }
  return (
    <>


      <Box px="15px" mt={2}>
        <Box sx={style.headerContainer}>
          <Typography sx={style.leaveHeading}>Cash Flow Statement</Typography>
          <Box display="flex" justifyContent={{ xs: "start", md: "end" }} alignItems={{ xs: "start", md: "end" }} mt={{xs:2, md: 0}}>
            <Button variant="contained" color="success" sx={style.csvBtns} onClick={() => handleDownload(month,year,viewType,"csv") } ><Download />
              {"CSV"}
            </Button>

            <Button variant="contained" color="success" sx={style.checkinBtns} onClick={() => handleDownload(month,year,viewType,"pdf")} ><Download />
              {"Export PDF"}
            </Button>


          </Box>
        </Box>


      </Box>
      <form>

        <Grid container sx={style.mainContainer}>
          <Grid item xs={12} lg={11.8} sx={style.gridbox}>
            <Box sx={style.inputSection}>
              <Box display="flex" sx={{mt:3}}>
                <Button variant="contained" color="success" onClick={() => setViewType("monthly")} 
                  sx={
                    {...style.monthlyBtn,
                      backgroundColor:viewType === "monthly" ? color.primary : "#DEDEDE",
                      color: viewType === "monthly" ? "#fff" : color.lightText
                    }}>Monthly
                </Button>
                <Button variant="contained" color="success" onClick={() => setViewType("quarterly")}
                  sx=
                    {{...style.checkoutBtn,
                      backgroundColor:viewType === "quarterly" ? color.primary :"#DEDEDE",
                      color: viewType === "quarterly" ? "#fff" : color.lightText
                    }} >Quarterly
                </Button>
              </Box>
              <Box sx={style.inputGrid}> 
                <Box sx={style.inputBox}>
                  <FormControl
                    fullWidth
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        height: "2.5em",
                        marginTop: "0.5em",
                        borderRadius: "10px",
                      },
                    }}
                  >
                    <Typography sx={style.inputText}>Select Month</Typography>
                    <Select
                      value={month || "" }
                      onChange={(e) => setMonth(e.target.value)}
                      name="customer"
                      sx={style.dropdown}
                    >
                      <MenuItem value = {""} disabled>Select</MenuItem>
                      {months?.map((month) => (
                        <MenuItem key={month} value={month}>
                          {month}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Box>
                <Box sx={style.inputBox}>
                  <FormControl
                    fullWidth
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        height: "2.5em",
                        marginTop: "0.5em",
                        borderRadius: "10px",
                      },
                    }}
                  >
                    <Typography sx={style.inputText}>Select Year</Typography>
                    <Select
                      value={year || ""}
                      onChange={(e) => setYear(e.target.value)}
                      name="type"
                      sx={style.dropdown}
                    >
                      <MenuItem value="" disabled>Select</MenuItem>
                      <MenuItem value="2025">2025</MenuItem>
                      <MenuItem value="2024">2024</MenuItem>
                      <MenuItem value="2023">2023</MenuItem>
                      <MenuItem value="2022">2022</MenuItem>
                    </Select>     
                  </FormControl>       </Box>
              

                <Box sx={style.createJob}>
                  <Button variant="contained" color="success" sx={style.jobButtons}
                    onClick={handleCashFlow}
                  >
                            Apply
                  </Button>
                </Box>
              </Box>

            </Box>
          </Grid>

          <Grid container spacing={2} px="15px">
            <Grid item md={4} xs={12}>
              <Box sx={style.card}>
                <Box>
                  <Typography sx={style.textHeading}>Total Cash in </Typography> <Typography sx={style.textBody}>{data?.totalCashIn?.toFixed(2) || 0} </Typography>
                </Box>
              </Box>
            </Grid>
            <Grid item md={4} xs={12}>
              <Box sx={style.card}>
                <Box>
                  <Typography sx={style.textHeading}>Total Cash Out</Typography> <Typography sx={style.textBody}>{data?.totalCashOut?.toFixed(2) || 0}</Typography>
                </Box>
              </Box>
            </Grid>
            <Grid item md={4} xs={12}>
              <Box sx={style.card}>
                <Box>
                  <Typography sx={style.textHeading}>Cash Flow Month End</Typography> <Typography sx={style.textBody}>{data?.cashAtEndOfMonth?.toFixed(2) || 0}</Typography>
                </Box>
              </Box>
            </Grid>


          </Grid>





        </Grid>


      </form>
      <Box sx={{ backgroundColor: color.card, m: 2, p:2, borderRadius: "20px" }}>
        <Box>
          <Typography sx={style.incomeText}>Income</Typography>
          <Typography>Category</Typography>
          <Box sx={style.lines}></Box>

          <Box sx={style.incomeGrid}>
            <Box sx={style.keySection}><Typography sx={style.incomeKey}>Net Income</Typography></Box>
            <Box><Typography sx={style.incomevalue}>{data?.netIncome?.toFixed(2)||0}</Typography></Box>
             

          </Box>
          <Box sx={style.line}></Box>
          <Box sx={style.incomeGrid}>
            <Box sx={style.keySection}><Typography sx={style.incomeKeys}>Additions to Cash</Typography></Box>
            <Box><Typography sx={style.incomevalue}></Typography></Box>
             

          </Box>
          <Box sx={style.incomeGrid}>
            <Box sx={style.keySection}><Typography sx={style.incomeKey}>Depreciation</Typography></Box>
            <Box><Typography sx={style.incomevalue}>0</Typography></Box>
             

          </Box>
          <Box sx={style.incomeGrid}>
            <Box sx={style.keySection}><Typography sx={style.incomeKey}>Increase in Account Payable</Typography></Box>
            <Box><Typography sx={style.incomevalue}>0</Typography></Box>
             

          </Box>
          <Box sx={style.line}></Box>
          <Box sx={style.incomeGrid}>
            <Box sx={style.keySection}><Typography sx={style.incomeKeys}>Subtractions from Cash</Typography></Box>
            <Box><Typography sx={style.incomevalue}></Typography></Box>
             

          </Box>
          <Box sx={style.incomeGrid}>
            <Box sx={style.keySection}><Typography sx={style.incomeKey}>Increase in Account Receivable</Typography></Box>
            <Box><Typography sx={style.incomevalueRed}>0</Typography></Box>
             

          </Box>
          <Box sx={style.incomeGrid}>
            <Box sx={style.keySection}><Typography sx={style.incomeKey}>Increase in Inventory</Typography></Box>
            <Box><Typography sx={style.incomevalueRed}>0</Typography></Box>
             

          </Box>
          <Box sx={style.incomeGrid}>
            <Box sx={style.keySection}><Typography sx={style.incomeKey}>Net Cash from Product</Typography></Box>
            <Box><Typography sx={style.incomevalue}>0</Typography></Box>
             

          </Box>
          <Box sx={style.line}></Box>
          <Box sx={style.incomeGrid}>
            <Box sx={style.keySection}><Typography sx={style.incomeKeys}>Cash Flow from Investing</Typography></Box>
            <Box><Typography sx={style.incomevalue}></Typography></Box>
             

          </Box>
          <Box sx={style.incomeGrid}>
            <Box sx={style.keySection}><Typography sx={style.incomeKey}>Purchase of Equipment</Typography></Box>
            <Box><Typography sx={style.incomevalueRed}>{data?.purchaseOfEquipment?.toFixed(2)||0}</Typography></Box>
             

          </Box>
          <Box sx={style.line}></Box>
          <Box sx={style.incomeGrid}>
            <Box sx={style.keySection}><Typography sx={style.incomeKeys}>Cash Flow from Financing</Typography></Box>
            <Box><Typography sx={style.incomevalue}></Typography></Box>
             

          </Box>
          <Box sx={style.incomeGrid}>
            <Box sx={style.keySection}><Typography sx={style.incomeKey}>Notes Payable</Typography></Box>
            <Box><Typography sx={style.incomevalue}>{0}</Typography></Box>
             

          </Box>
          <Box sx={style.line}></Box>
          <Box sx={style.incomeGrid}>
            <Box sx={style.keySection}><Typography sx={style.incomeKeyCash}>Cash at the end of Month</Typography></Box>
            <Box><Typography sx={style.incomevalue}>{data?.cashAtEndOfMonth?.toFixed(2) || 0}</Typography></Box>
             

          </Box>

        </Box>
      </Box>

    </>
  )
}
export default CashFlowStatement;
